import SetNewBillableRate from './SetNewBillableRateModal';

export default SetNewBillableRate;
